import React from "react";
import { MobileFilled, QrcodeOutlined, MailFilled, PhoneFilled, KeyOutlined } from "@ant-design/icons";

export const UserType = {
  Group: 1,
  Transporter: 2,
  Dealer: 3,
};

export const RoleType = {
  Admin: 1,
  Transporter: 2,
  Dealer: 3,
};

export const UserTypeToRoletype = {
  [UserType.Group]: RoleType.Dealer,
  [UserType.Transporter]: RoleType.Transporter,
  [UserType.Dealer]: RoleType.Dealer,
};

export const ProfilePictureStatus = {
  Idle: 0,
  Uploading: 1,
  Success: 2,
};

export const ScanStatuses = {
  NOT_SCANNED: 1,
  SUCCESS: 2,
  FAIL: 3,
  MANUAL_SUCCESS: 4,
  MANUAL_FAIL: 5,
};

export const LoadPaymentStatusToMelioStatusMap = {
  0: "unpaid",
  1: "paid",
  2: "scheduled",
  3: "unpaid",
  4: "unpaid",
};

export const RouteReasonMap = {
  1: "Outside major metro",
  2: "Low traffic area",
  3: "Other",
};

export const VehicleType = {
  Car: 1,
  Truck: 2,
  SUV: 3,
  Van: 4,
  Other: 5,
  Motorcycle: 6,
  ATV_UTV: 7,
  Coupe: 8,
  EV: 9,
};

export const VehicleTypeMap = {
  [VehicleType.Car]: "Car",
  [VehicleType.Truck]: "Truck",
  [VehicleType.SUV]: "SUV",
  [VehicleType.Van]: "Van",
  [VehicleType.Other]: "Other",
  [VehicleType.Motorcycle]: "Motorcycle",
  [VehicleType.ATV_UTV]: "ATV/UTV",
};

export const ShipmentIncompleteStatus = {
  NOT_APPLICABLE: 1,
  INCIDENT: 2,
  MISINFORMATION: 3,
  NOT_AVAILABLE: 4,
  CANCELLED: 5,
  DRY_RUN: 6,
  EXCHANGE_SET_TO_INCOMPLETE: 7,
};

export const IncompleteStatusMap = {
  1: "Not Applicable",
  2: "Incident",
  3: "Misinformation",
  4: "Not Available",
  5: "Cancelled",
  6: "Dry Run",
};

export const incompleteSubStatusOptions = [
  { value: ShipmentIncompleteStatus.INCIDENT, title: "Incident" },
  {
    value: ShipmentIncompleteStatus.MISINFORMATION,
    title: "Misinformation",
  },
  {
    value: ShipmentIncompleteStatus.NOT_AVAILABLE,
    title: "Not Available",
  },
  { value: ShipmentIncompleteStatus.CANCELLED, title: "Cancelled" },
  { value: ShipmentIncompleteStatus.DRY_RUN, title: "Dry run" },
];

export const ShipmentStatus = {
  Draft: 1,
  Pending: 2,
  Completed: 3,
  Posted: 4,
  Assigned: 5,
  Delivered: 6,
  Incomplete: 7,
};

export const ShipmentStatusMap = {
  [ShipmentStatus.Draft]: "Draft",
  [ShipmentStatus.Pending]: "Pending",
  [ShipmentStatus.Completed]: "Completed",
  [ShipmentStatus.Posted]: "Posted",
  [ShipmentStatus.Assigned]: "Assigned",
  [ShipmentStatus.Delivered]: "Delivered",
  [ShipmentStatus.Incomplete]: "Incomplete",
};

export const ShipmentStatusColorMap = {
  [ShipmentStatus.Draft]: "#D9D9D9",
  [ShipmentStatus.Pending]: "#FFA726",
  [ShipmentStatus.Completed]: "#62DAAB",
  [ShipmentStatus.Posted]: "#2D6AC4",
  [ShipmentStatus.Assigned]: "#52c41a",
  [ShipmentStatus.Delivered]: "#722ed1",
  [ShipmentStatus.Incomplete]: "#F5222D",
};

export const NissanVehicleStatus = {
  Available: 1,
  Processed: 2,
  ShippedManually: 3,
  ExceptionDriverRemoved: 4,
};

export const NissanVehicleStatusMap = {
  [NissanVehicleStatus.Available]: "Available",
  [NissanVehicleStatus.Processed]: "Processed",
  [NissanVehicleStatus.ShippedManually]: "Shipped Manually",
  [NissanVehicleStatus.ExceptionDriverRemoved]: "Exception Driver Removed",
};

export const NissanVehicleStatusColorMap = {
  [NissanVehicleStatus.Available]: "green",
  [NissanVehicleStatus.Processed]: "blue",
  [NissanVehicleStatus.ShippedManually]: "magenta",
  [NissanVehicleStatus.ExceptionDriverRemoved]: "orange",
};

export const LoadStatus = {
  Active: 1,
  PickedUp: 2,
  Delivered: 3,
  Completed: 4,
  Incomplete: 5,
};

export const LoadStatusMap = {
  [LoadStatus.Active]: "Active",
  [LoadStatus.PickedUp]: "Picked Up",
  [LoadStatus.Delivered]: "Delivered",
  [LoadStatus.Completed]: "Completed",
  [LoadStatus.Incomplete]: "Incomplete",
};

export const WeekDays = {
  MONDAY: "MON",
  TUESDAY: "TUE",
  WEDNESDAY: "WED",
  THURSDAY: "THU",
  FRIDAY: "FRI",
  SATURDAY: "SAT",
  SUNDAY: "SUN",
};

export const WeekDaysMap = {
  [WeekDays.MONDAY]: "MON",
  [WeekDays.TUESDAY]: "TUE",
  [WeekDays.WEDNESDAY]: "WED",
  [WeekDays.THURSDAY]: "THU",
  [WeekDays.FRIDAY]: "FRI",
  [WeekDays.SATURDAY]: "SAT",
  [WeekDays.SUNDAY]: "SUN",
};

export const HardRouteLocation = {
  NormalRoute: 1,
  DifficultPickup: 2,
  DifficultDropoff: 3,
  Both: 4,
};

export const HardRouteLocationMap = {
  1: "Neither",
  2: "Pickup",
  3: "Dropoff",
  4: "Both",
};

export const ShipmentStatusStep = {
  [ShipmentStatus.Draft]: 0,
  [ShipmentStatus.Pending]: 1,
  [ShipmentStatus.Completed]: 1,
  [ShipmentStatus.Posted]: 2,
  [ShipmentStatus.Assigned]: 3,
  [ShipmentStatus.Delivered]: 4,
  [ShipmentStatus.Incomplete]: 5,
};

export const QuoteStatus = {
  None: 1,
  Pending: 2,
  Completed: 3,
  Expired: 4,
};

export const QuoteStatusMap = {
  [QuoteStatus.None]: "None",
  [QuoteStatus.Pending]: "Pending",
  [QuoteStatus.Completed]: "Completed",
  [QuoteStatus.Expired]: "Expired",
};

export const PricingEngineResultStatus = {
  Success: 1,
  Warning: 2,
  Error: 3,
};

export const PricingEngineResultStatusMap = {
  [PricingEngineResultStatus.Success]: {
    message: "Success",
    type: "success",
  },
  [PricingEngineResultStatus.Warning]: {
    message: "Warning",
    type: "warning",
  },
  [PricingEngineResultStatus.Error]: {
    message: "Error",
    type: "error",
  },
};

export const QuoteRulesResults = {
  Warning: 1,
  Error: 2,
};

export const GatePassStatus = {
  NotRequired: 1,
  Pending: 2,
  Attached: 3,
};

export const GatePassStatusMap = {
  [GatePassStatus.NotRequired]: "Not Required",
  [GatePassStatus.Pending]: "Pending",
  [GatePassStatus.Attached]: "Attached",
};

export const GatePassStatusColor = {
  1: "default",
  2: "processing",
  3: "success",
};

export const GatePassStatusColorLabel = {
  1: "Not Required",
  2: "Pending",
  3: "Attached",
};

export const MediaPurpose = {
  Other: 1,
  GatePass: 2,
  TransporterCOI: 3,
  TransporterW9: 4,
  ProfilePicture: 5,
  BillOfLading: 6,
  Signature: 7,
  BillOfLadingAdditional: 8,
};

export const Drivability = {
  RideAndDrive: 1,
  Inoperational: 2,
};

export const DrivabilityMap = {
  1: "Ride and Drive",
  2: "Inoperational",
};

export const TrailerType = {
  Open: 1,
  Enclosed: 2,
};

export const TrailerTypeMap = {
  1: "Open Trailer",
  2: "Enclosed",
};

export const CompanyStatus = {
  Active: 1,
  Duplicate: 2,
  Block: 3,
  MissingInfo: 4,
};

export const CompanyStatusMap = {
  [CompanyStatus.Active]: "Active",
  [CompanyStatus.Duplicate]: "Duplicate",
  [CompanyStatus.Block]: "Block",
  [CompanyStatus.MissingInfo]: "Missing Info",
};

export const Integrations = {
  WWL: 1,
};

export const AssociatedUserType = {
  Company: 1,
  Group: 2,
};

export const ShipmentCancelReason = {
  Price: 1,
  NoLongerNeeded: 2,
  DealFellThrough: 3,
  VehicleMechanicalIssues: 4,
  Other: 5,
};

export const DealerExchangeType = {
  Ordered: 1,
  Unordered: 2,
};

export const DealerExchangeTypeMap = {
  [DealerExchangeType.Ordered]: "ordered",
  [DealerExchangeType.Unordered]: "unordered",
};

export const EntityType = {
  Dealer: 1,
  Transporter: 2,
  DealerAdmin: 3,
};

export const EntityTypeMap = {
  [EntityType.Dealer]: "Dealer",
  [EntityType.Transporter]: "Transporter",
  [EntityType.DealerAdmin]: "Dealer Admin",
};

export const NoteType = {
  Dealer: 1,
  Transporter: 2,
  Company: 3,
  User: 4,
  Shipment: 5,
  Quote: 6,
};

export const PriceAdjustType = {
  ToDollarAmmount: 1,
  ByDollarAmmount: 2,
  ByPercentage: 3,
};

export const PriceAdjustmentDirection = {
  Increase: 1,
  Decrease: 2,
};

export const Orientation = {
  Horizontal: 1,
  Vertical: 2,
};

export const FlagNotesType = {
  AutosledExpedited: 1,
  ProblemRide: 2,
  IsDamaged: 3,
};

export const QuoteFeedbackType = {
  ThinkWrong: 1,
  MarketForces: 2,
  BulkDeal: 3,
  LossLeader: 4,
  NegotiatedRoute: 5,
  Other: 6,
  InvalidRule: 7,
};

export const QuoteFeedbackTypeMap = {
  1: "Think it is wrong",
  2: "Market forces",
  3: "Bulk deal",
  4: "Loss leader",
  5: "Negotiated route",
  6: "Other",
  7: "Invalid Rule",
};

export const VehicleColor = {
  Beige: "Beige",
  Black: "Black",
  Blue: "Blue",
  Brown: "Brown",
  Gray: "Gray",
  Green: "Green",
  LightBlue: "LightBlue",
  Orange: "Orange",
  Red: "Red",
  Silver: "Silver",
  White: "White",
  Yellow: "Yellow",
  Other: "Other",
};

export const FixedByZipPriceType = {
  Fixed: 1,
  Adjustable: 2,
};

export const FixedByZipPriceTypeMap = {
  1: "Fixed",
  2: "Adjustable",
};

export const FixedByZipDirectionType = {
  OneWay: 1,
  Both: 2,
};

export const FixedByZipDirectionTypeMap = {
  1: "One Way",
  2: "Both",
};

export const LoadTimeSlot = {
  EighthAmToTwelvePm: 1,
  TwelvePmToFourPm: 2,
  FourPmToEighthPm: 3,
};

export const LoadTimeSlotMap = {
  1: "8 AM to 12 PM",
  2: "12 PM to 4 PM",
  3: "4 PM to 8 PM",
};

export const AssociateWithUserType = {
  CreateNewUser: 1,
  AssociateWithExistingUser: 2,
};

export const BillOfLadingType = {
  Pickup: 1,
  DropOff: 2,
};

export const BillOfLadingStatus = {
  DRAFT: 1,
  FAILED: 2,
  COMPLETE: 3,
};

export const BillOfLadingMediaPurpose = {
  Front: 1,
  Rear: 2,
  Roof: 3,
  DriverSide: 4,
  PassengerSide: 5,
  CornerFrontPassenger: 6,
  CornerFrontDriver: 7,
  CornerRearPassenger: 8,
  CornerRearDriver: 9,
  Odometer: 10,
  Signatures: 11,
  Additional: 12,
};

export const BillStatus = {
  Unpaid: 1,
  Paid: 2,
  Pending: 3,
  LoadIssues: 4,
  ACHIssues: 5,
};

export const BillStatusMap = {
  1: "Unpaid",
  2: "Paid",
  3: "Pending",
  4: "Load Issues",
  5: "ACH Issues",
};

export const InvoiceStatus = {
  NotReceived: 1,
  Billed: 2,
  Received: 3,
  Pending: 4,
};

export const InvoiceStatusMap = {
  1: "Not Received",
  2: "Billed",
  3: "Received",
  4: "Pending",
};

export const BillStatusColorMap = {
  1: { label: "Unpaid", color: "#d4af37" },
  2: { label: "Paid", color: "#52c41a" },
  3: { label: "Pending", color: "#f5222d" },
  4: { label: "Load Issues", color: "purple" },
  5: { label: "ACH Issues", color: "orange" },
};

export const InvoiceStatusColorMap = {
  1: { label: "Not Received", color: "#f5222d" },
  2: { label: "Billed", color: "#2D6AC4" },
  3: { label: "Received", color: "#52c41a" },
  4: { label: "Pending", color: "#d4af37" },
};

export const EMPTY_BOL = {
  PICKUP: "no-pickup",
  DROPOFF: "no-dropoff",
};

export const EMPTY_BOL_MAP = {
  [EMPTY_BOL.PICKUP]: "picked up",
  [EMPTY_BOL.DROPOFF]: "dropped off",
};

export const TransporterDispatchLevel = {
  NoDispatch: 1,
  DispatcherOnly: 2,
  DispatcherAndDriver: 3,
};

export const TransporterDispatchLevelMap = {
  [TransporterDispatchLevel.NoDispatch]: "No Dispatch",
  [TransporterDispatchLevel.DispatcherOnly]: "Dispatcher Only",
  [TransporterDispatchLevel.DispatcherAndDriver]: "Dispatcher and Driver",
};

export const TransporterRoles = {
  Admin: "Transporter Admin",
  Dispatcher: "Dispatcher",
  Driver: "Driver",
};

export const RolesNames = {
  AUTOSLED_ADMIN: "Autosled Admin",
};

export const ShipmentIncompleteReason = {
  Other: 1,
  Price: 2,
  NoLongerNeeded: 3,
  DealFellThrough: 4,
  VehicleMechanicalIssues: 5,
  NoResponseFromTransporter: 6,
  TooManyETAChanges: 7,
  ChangeOfRoute: 8,
  EquipmentMalfunction: 9,
  UnitNotReady: 10,
  UnitNotAsDescribed: 11,
  Reconsidered: 12,
  RenegotiatingRate: 13,
  NoGatepass: 14,
  NoPSI: 15,
  UnitDoesntFit: 16,
  CantMakeETA: 17,
  DriverSwitch: 18,
  PickupLocationIssue: 19,
};

export const ShipmentIncompleteInitiatedBy = {
  Autosled: 1,
  Dealer: 2,
  Transporter: 3,
};

export const initiatedByOptions = [
  { value: ShipmentIncompleteInitiatedBy.Autosled, title: "Autosled" },
  { value: ShipmentIncompleteInitiatedBy.Dealer, title: "Dealer" },
  {
    value: ShipmentIncompleteInitiatedBy.Transporter,
    title: "Transporter",
  },
];

export const autosledReasons = [
  {
    value: ShipmentIncompleteReason.NoResponseFromTransporter,
    title: "No Response from Transporter",
  },
  {
    value: ShipmentIncompleteReason.TooManyETAChanges,
    title: "Too Many ETA Changes",
  },
  {
    value: ShipmentIncompleteReason.ChangeOfRoute,
    title: "Change of Route",
  },
  {
    value: ShipmentIncompleteReason.EquipmentMalfunction,
    title: "Equipment Malfunction",
  },
  { value: ShipmentIncompleteReason.Other, title: "Other" },
];

export const dealerReasons = [
  { value: ShipmentIncompleteReason.Price, title: "Price" },
  {
    value: ShipmentIncompleteReason.NoLongerNeeded,
    title: "No Longer Needed",
  },
  {
    value: ShipmentIncompleteReason.DealFellThrough,
    title: "Deal Fell Through",
  },
  {
    value: ShipmentIncompleteReason.VehicleMechanicalIssues,
    title: "Vehicle Mechanical Issues",
  },
  { value: ShipmentIncompleteReason.Other, title: "Other" },
];

export const transporterReasons = [
  {
    value: ShipmentIncompleteReason.EquipmentMalfunction,
    title: "Equipment Malfunction",
  },
  {
    value: ShipmentIncompleteReason.ChangeOfRoute,
    title: "Change of Route",
  },
  {
    value: ShipmentIncompleteReason.UnitNotReady,
    title: "Unit Not Ready",
  },
  {
    value: ShipmentIncompleteReason.UnitNotAsDescribed,
    title: "Unit Not As Described",
  },
  {
    value: ShipmentIncompleteReason.Reconsidered,
    title: "Reconsidered",
  },
  {
    value: ShipmentIncompleteReason.RenegotiatingRate,
    title: "Renegotiating Rate",
  },
  { value: ShipmentIncompleteReason.NoGatepass, title: "No Gatepass" },
  { value: ShipmentIncompleteReason.NoPSI, title: "No PSI" },
  {
    value: ShipmentIncompleteReason.UnitDoesntFit,
    title: "Unit Doesn't Fit",
  },
  {
    value: ShipmentIncompleteReason.CantMakeETA,
    title: "Can't Make ETA",
  },
  {
    value: ShipmentIncompleteReason.DriverSwitch,
    title: "Driver Switch",
  },
  {
    value: ShipmentIncompleteReason.PickupLocationIssue,
    title: "Pickup Location Issue",
  },
  { value: ShipmentIncompleteReason.Other, title: "Other" },
];

export const reasons = {
  [ShipmentIncompleteInitiatedBy.Autosled]: autosledReasons,
  [ShipmentIncompleteInitiatedBy.Dealer]: dealerReasons,
  [ShipmentIncompleteInitiatedBy.Transporter]: transporterReasons,
};

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};

export const VehicleSize = {
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3,
  XL: 4,
  UNKNOWN: 5,
};

export const VehicleSizeMap = {
  [VehicleSize.SMALL]: "Small",
  [VehicleSize.MEDIUM]: "Medium",
  [VehicleSize.LARGE]: "Large",
  [VehicleSize.XL]: "XL",
  [VehicleSize.UNKNOWN]: "Unknown",
};

export const SecurePassAutoSend = {
  NOT_SEND: 1,
  DEFAULT: 2,
  SEND: 3,
};

export const SecurePassAutoSendMap = {
  [SecurePassAutoSend.NOT_SEND]: "Do Not Send",
  [SecurePassAutoSend.DEFAULT]: "Default",
  [SecurePassAutoSend.SEND]: "Send",
};

export const LocationType = {
  Pickup: "Pickup",
  Dropoff: "Dropoff",
};

export const SecurePassStatus = {
  Pending: 1,
  Completed: 2,
  ManualCompleted: 3,
};

export const SECURE_PASS_TAG_STATUS = {
  Disabled: 1,
  MissingContact: 2,
  Enabled: 3,
  FailedValidation: 4,
  FailedOutreach: 5,
};

export const SECURE_PASS_TAG_STATUS_MAP = {
  [SECURE_PASS_TAG_STATUS.Disabled]: "Disabled",
  [SECURE_PASS_TAG_STATUS.MissingContact]: "Needs Info",
  [SECURE_PASS_TAG_STATUS.Enabled]: "Enabled",
  [SECURE_PASS_TAG_STATUS.FailedOutreach]: "Failed Outreach",
  [SECURE_PASS_TAG_STATUS.FailedValidation]: "Failed Validation",
};

export const SecurePassLogType = {
  QRScanned: 1,
  VerificationAttempt: 2,
  OutreachAttempt: 3,
  QRCodeRetrieved: 4,
  SecurePassSend: 5,
};

export const SecurePassLogTypeMap = {
  [SecurePassLogType.QRScanned]: "QR Scanned",
  [SecurePassLogType.VerificationAttempt]: "Verification Attempt",
  [SecurePassLogType.OutreachAttempt]: "Outreach Attempt",
  [SecurePassLogType.QRCodeRetrieved]: "QR Code Retrieved",
  [SecurePassLogType.SecurePassSend]: "Secure Pass Send",
};

export const SecurePassLogTypeIcon = {
  [SecurePassLogType.QRScanned]: <MobileFilled />,
  [SecurePassLogType.QRCodeRetrieved]: <QrcodeOutlined />,
  [SecurePassLogType.SecurePassSend]: <MailFilled />,
  [SecurePassLogType.OutreachAttempt]: <PhoneFilled />,
  [SecurePassLogType.VerificationAttempt]: <KeyOutlined />,
};

export const SALESFORCE_TYPE = {
  ACCOUNT: "Account",
  CONTACT: "Contact",
};
